import request from '@/router/axios'
import env from '@/config/env'
/**
 * 司机佣金规则列表

 * @param data
 *
 */
export const list = (data) => {
  return request({
    url: env.ferryUrl + '/driver/promoter/rule/page',
    method: 'POST',
    data
  })
}
/**
 * 新增/编辑
 * @param data
 *
 */
export const addOrEdit = (data) => {
  return request({
    url: env.ferryUrl + '/driver/promoter/rule/save',
    method: 'POST',
    data
  })
}

/**
 * 删除
 * @param data
 *
 */
export const remove = (merchantId) => {
  return request({
    url: env.ferryUrl + `/driver/promoter/rule/del?merchantId=${merchantId}`,
    method: 'DELETE'
  })
}

/**
 * 详情
 * @param data
 *
 */
export const detail = (merchantId) => {
  return request({
    url: env.ferryUrl + `/driver/promoter/rule/info?merchantId=${merchantId}`,
    method: 'get'
  })
}

/**
 * 获取司推官收入分页
 * @param data
 *
 */
export const getIncomePage = (data) => {
  return request({
    url: env.ferryUrl + '/driver/promoter/income-page',
    method: 'post',
    data
  })
}
/**
 * 司推官收入导出
 * @param data
 *
 */
export const incomeExport = (data) => {
  return request({
    url: env.ferryUrl + '/driver/promoter/income-export',
    method: 'post',
    data
  })
}

/**
 * 获取司推官看板
 * @param data
 *
 */
export const getBoard = (data) => {
  return request({
    url: env.ferryUrl + '/driver/promoter/board',
    method: 'post',
    data
  })
}
/**
 * 修改司推官状态
 * @param data
 *
 */
export const changeStatus = (data) => {
  return request({
    url:
      env.ferryUrl +
      `/driver/promoter/change-status?driverId=${data.driverId}&status=${data.status}`,
    method: 'put'
  })
}
